import React from "react";

import { Chip } from "@mui/material";

import { SENSOR_CHIP_SX } from "components/sensors/table/chips/sensor-chip-style";
import { SENSOR_STATUS_COLOR } from "components/sensors/table/chips/sensor-status-color";

const PILL_WIDTH = "116px";

// Shared by Sensors (online) and Gateways (isGatewayConnected) -- same
// label/color logic, just a different source for the boolean.
export function ConnectionStatusChip({ connected }: { connected: boolean }) {
  const pillColor = connected
    ? SENSOR_STATUS_COLOR.positive
    : SENSOR_STATUS_COLOR.negative;
  return (
    <Chip
      size="small"
      label={connected ? "Connected" : "Disconnected"}
      sx={{ ...SENSOR_CHIP_SX, width: PILL_WIDTH, ...pillColor }}
    />
  );
}
